import { Tag } from "antd";
import React from "react";
import { BAND_COLORS, consumptionBand } from "../lib/consumption-bands";

interface ConsumptionPctCellProps {
  pct: number | null;
  budgetPending: boolean;
}

export const ConsumptionPctCell: React.FC<ConsumptionPctCellProps> = ({
  pct,
  budgetPending,
}) => {
  if (budgetPending) {
    return (
      <>
        - <Tag>fee pending</Tag>
      </>
    );
  }
  if (pct === null) return <Tag>N/A</Tag>;
  return <Tag color={BAND_COLORS[consumptionBand(pct)]}>{pct}%</Tag>;
};
